import gsap from 'gsap'
import SmoothScroll from '../utils/SmoothScroll'

export default class Menu {
	constructor() {
		this.overlay = document.querySelector('[data-menu-overlay]')
		this.buttons = document.querySelectorAll('[data-toggle-menu]')
		this.staggerContainers = document.querySelectorAll('[data-stagger-items]')
		this.menu = document.querySelector('[data-menu]')
		this.main = document.querySelector('main')
		this.isOpen = false
		this.lenis = new SmoothScroll().lenis

		this.#bindEvents()
	}

	#bindEvents() {
		this.buttons.forEach(btn => {
			btn.addEventListener('click', () => this.toggle())
		})

		this.main?.addEventListener('click', () => {
			if (this.isOpen) this.close()
		})

		document.addEventListener('keydown', e => {
			if (e.key === 'Escape' && this.isOpen) this.close()
		})
	}

	toggle() {
		this.isOpen ? this.close() : this.open()
	}

	open() {
		this.isOpen = true
		document.documentElement.classList.add('overflow-hidden')
		this.overlay?.classList.add('active')
		this.lenis.stop()
		gsap.to(this.menu, { x: 0, duration: 0.5, ease: 'power3.inOut' })

		this.staggerContainers.forEach(container => {
			gsap.from(gsap.utils.toArray(container.children), {
				y: 32,
				opacity: 0,
				delay: 0.35,
				stagger: 0.1,
				duration: 0.4,
			})
		})
	}

	close() {
		this.isOpen = false
		this.lenis.start()
		document.documentElement.classList.remove('overflow-hidden')
		this.overlay?.classList.remove('active')
		gsap.to(this.menu, { x: '100%', duration: 0.5, ease: 'power3.inOut' })
	}
}
